import React from 'react';

export default function Loans() {
  return (
    <div>Loans</div>
  );
}
